const DEFAULT_IAM_CLIENT = "default";
const iamClientPath = `/api/core/v1/iam/clients/${DEFAULT_IAM_CLIENT}`;
const iamClientActionsPath = `${iamClientPath}/actions`;
// The ecosystem runs once, on the central platform; an installation has none of
// its own, so a request under this path is always answered centrally.
export const ECOSYSTEM_API_PATH = "/api/ecosystem/v1";
const ecosystemApiPath = ECOSYSTEM_API_PATH;
const iamUsersPath = "/api/core/v1/iam/users";

export const API_ROUTES = {
    ecosystem: {
        billingAccount: `${ecosystemApiPath}/billing/account/`,
        realms: `${ecosystemApiPath}/realms/`,
        realmTelemetry: (realmUuid: string) =>
            `${ecosystemApiPath}/realms/${encodeURIComponent(realmUuid)}/telemetry/`,
        settings: `${ecosystemApiPath}/settings/`,
        ui: {
            components: `${ecosystemApiPath}/ui/components/`,
            // What each kind of component carries, read once per kind rather
            // than with every component.
            componentSpecs: `${ecosystemApiPath}/ui/component_specs/`,
            componentsBatch: `${ecosystemApiPath}/ui/components/batch/`,
            // A batch delete names the components in its body, and a body
            // belongs to a POST rather than to the DELETE of one component's
            // own address.
            componentsBatchDelete: `${ecosystemApiPath}/ui/components/batch/delete/`,
            sidebarItems: `${ecosystemApiPath}/ui/sidebar_items/`,
            // The pages an administrator marked with a public path, and the
            // components they are built from. They are answered without a
            // token, which is how a visitor who is not signed in reads the
            // storefront.
            publicComponents: `${ecosystemApiPath}/ui/public_components/`,
            publicSidebarItems: `${ecosystemApiPath}/ui/public_sidebar_items/`,
        },
    },
    iam: {
        users: `${iamUsersPath}/`,
        confirmEmail: (userId: string) =>
            `${iamUsersPath}/${userId}/actions/confirm_email/invoke`,
        resetPassword: (userId: string) =>
            `${iamUsersPath}/${userId}/actions/reset_password/invoke`,
        sendResetPasswordCode: `${iamClientActionsPath}/send_reset_password_code/invoke`,
        defaultClient: iamClientPath,
        token: `${iamClientActionsPath}/get_token/invoke`,
        introspect: `${iamClientActionsPath}/introspect`,
        me: `${iamClientActionsPath}/me`,
        logout: `${iamClientActionsPath}/logout/invoke`,
        projects: "/api/core/v1/iam/projects/",
        organization: (organizationUuid: string) =>
            `/api/core/v1/iam/organizations/${encodeURIComponent(organizationUuid)}`,
        addUserToProject: (projectUuid: string) =>
            `/api/core/v1/iam/projects/${projectUuid}/actions/add_user/invoke`,
        roles: "/api/core/v1/iam/roles/",
        permissions: "/api/core/v1/iam/permissions/",
        roleBindings: "/api/core/v1/iam/role_bindings/",
        permissionBindings: "/api/core/v1/iam/permission_bindings/",
    },
} as const;
